import React, { useState } from "react";

import { ReferenciaCabecera } from "../../../interfaces/ReferenciaCabecera";
import { normalizeTwoWords, formatImageAlt } from "../../../shared/utils/stringUtilities";
import Breadcrumb from "../../atoms/breadcrumb/breadcrumb";
import ShareModal from "../../molecules/share-modal/shareModal";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";

import "./headboardClubDetail.scss";

const HeadboardClubDetail = (props: ReferenciaCabecera) => {
  const {
    tituloPrincipal = "",
    descripcion = "",
    botonCompartir = "Compartir",
    tituloBoton = "",
    imagenHeader,
  } = props[0];

  const { isBrowser, window } = useBrowserMode();

  const arrayBreadCrumb = props[0].migaDePan.split("/");
  const gtmCategory =
    arrayBreadCrumb && arrayBreadCrumb.length > 0 ? arrayBreadCrumb[2] : "";

  const href = isBrowser ? window.location.href : "";

  const [isModalVisible, setIsModalVisible] = useState(false);

  const toggleModal = () => setIsModalVisible(!isModalVisible);

  return (
    <section className="o-headboard-club-detail">
      <Breadcrumb content={`${props[0].migaDePan}`} />
      <div className="o-headboard-club-detail__content">
        <div className="o-headboard-club-detail__content__texts">
          <h1 className="o-headboard-club-detail__content__texts__title">
            {tituloPrincipal}
          </h1>
          <p className="o-headboard-club-detail__content__texts__location">
            {descripcion.json.content[0].content[0].value}
          </p>
          <p className="o-headboard-club-detail__content__texts__people">
            {descripcion.json.content[0].content[1].value}
          </p>
          <p className="o-headboard-club-detail__content__texts__more-info">
            {tituloBoton}
          </p>
          <p
            className={`o-headboard-club-detail__content__texts__share gtm${normalizeTwoWords(
              gtmCategory
            )}${normalizeTwoWords(tituloPrincipal)}Compartir`}
            onClick={() => toggleModal()}
          >
            <span className="icon-share"></span>
            {botonCompartir}
          </p>
          <p
            className="icon-share 
              o-headboard-club-detail__content__texts__share-mobile"
            onClick={() => toggleModal()}
          ></p>
        </div>
        <div className="o-headboard-club-detail__content__image">
          <img
            src={imagenHeader.file.url}
            alt={formatImageAlt(imagenHeader.title)}
          />
        </div>
      </div>
      <ShareModal open={isModalVisible} onClose={toggleModal} href={href} />
    </section>
  );
};

export default HeadboardClubDetail;
